module.exports = __webpack_public_path__ + "img/open-market-header-mobile.b604ce40.webp";